import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import CourseConflictInfo, { IDispatchProps } from './index';
import { logout } from '../../../store/auth/actions';

const mapDispatchToProps = (dispatch: Dispatch): IDispatchProps => ({
  onLogout: () => {
    dispatch(logout());
  },
});

export default connect(null, mapDispatchToProps)(CourseConflictInfo);
